import React from "react";

export interface OrganizationContextManager{
  organizationID: string | null;
  setOrganizationID: (droneID: string | null) => void;
};

export const OrganizationContext = React.createContext<OrganizationContextManager | null>(null);
